import React, { Component } from 'react';
import { userService } from '../_services'
import { history } from '../_helpers'
export class LogOut extends Component {
    static displayName = LogOut.name;
    componentDidMount() {
        userService.logout(); 
        history.push("/LogInMain")
      }
    render() {
        return (
            <div>
                <h1>Log Out</h1>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/LogOut.js